import { WORK_DAYS } from "../const";

const reformatDays = days => {
  const horairesGardeDto = {
    horraireHiver: {},
    horraireEte: {}
  };

  WORK_DAYS.forEach(day => {
    let newData = Object.assign({}, days[day]);
    newData.ouvert = !days[day].disable;
    delete newData.disable;
    horairesGardeDto.horraireHiver[day] = newData;
    horairesGardeDto.horraireEte[day] = newData;
  });

  return horairesGardeDto;
};

export { reformatDays };
